<template>
<div>
    The map chart <i class="ui globe chart icon"></i> is not implemented in the prototype.  You can see how it will look in <a target="_new" href="https://www.dropbox.com/sh/lfrn4lcjyqhou7o/AAAmzec_63b1UwaZCGFDw1gea?dl=0&preview=Detail+Page+Country+Breakdown.png">the design here</a>.
</div>
</template>

<script>
export default {
    name: 'map-chart',
    props: ['data']
}
</script>



// WEBPACK FOOTER //
// MapChart.vue?2746be52